"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { Skeleton, Carousel } from "@nxt-costco-com/forge-components";
import { SpaceMd, SpaceXs, SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
import { ProductTileSkeleton } from "../../../Product/ProductTile/ProductTileUI/view.skeleton.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
import { ProductTileContainerSkeletonSx, ProductTileContainerSx } from "./styles.js";
function ProductTileCarouselSkeleton({
  expectedProductNumber,
  maxItemsPerSlide,
  containerSx = {},
  isHorizontal,
  minProductTileImageWidth,
  titleProps,
  carouselContainerSx
}) {
  return /* @__PURE__ */ jsxs(CostcoBox, { children: [
    (titleProps == null ? void 0 : titleProps.title) && /* @__PURE__ */ jsx(CostcoBox, { sx: { marginBottom: SpaceMd }, children: /* @__PURE__ */ jsx(Skeleton, { height: 40, variant: "rectangular" }) }),
    /* @__PURE__ */ jsx(
      CostcoBox,
      {
        sx: {
          alignItems: "center",
          display: "flex",
          justifyContent: "flex-start",
          width: "100%"
        },
        children: /* @__PURE__ */ jsxs(CostcoBox, { sx: carouselContainerSx, children: [
          /* @__PURE__ */ jsx(
            Carousel,
            {
              items: [...Array(expectedProductNumber).keys()].map(
                (_, index) => {
                  return /* @__PURE__ */ jsx(
                    CostcoBox,
                    {
                      sx: {
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                        padding: isHorizontal ? 0 : SpaceXxs,
                        paddingBottom: isHorizontal ? 0 : SpaceXs,
                        ...containerSx
                      },
                      children: /* @__PURE__ */ jsx(
                        CostcoBox,
                        {
                          sx: {
                            ProductTileContainerSx,
                            ...ProductTileContainerSkeletonSx,
                            ...containerSx
                          },
                          children: /* @__PURE__ */ jsx(
                            ProductTileSkeleton,
                            {
                              minProductTileImageWidth,
                              isHorizontal
                            }
                          )
                        }
                      )
                    },
                    `productTile-skeleton-${index}`
                  );
                }
              ),
              itemsPerSlide: Math.min(
                expectedProductNumber,
                maxItemsPerSlide
              )
            }
          ),
          !isHorizontal && /* @__PURE__ */ jsxs(
            CostcoBox,
            {
              sx: {
                display: "flex",
                flexDirection: "row",
                gap: 2,
                justifyContent: "center",
                minHeight: "56px"
              },
              children: [
                /* @__PURE__ */ jsx(
                  Skeleton,
                  {
                    height: 20,
                    variant: "circular",
                    width: 20
                  }
                ),
                /* @__PURE__ */ jsx(
                  Skeleton,
                  {
                    height: 20,
                    variant: "circular",
                    width: 20
                  }
                ),
                /* @__PURE__ */ jsx(
                  Skeleton,
                  {
                    height: 20,
                    variant: "circular",
                    width: 20
                  }
                )
              ]
            }
          )
        ] })
      }
    )
  ] });
}
export {
  ProductTileCarouselSkeleton
};
